import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// --------------------------------------------------------
// ENDPOINTS
// --------------------------------------------------------
const API_BASE = "/admin/request-status";

export async function updateRequestStatus(payload = {}) {
  const cookies = new Cookies();
  const token = cookies.get("token");

  return AxiosInstance.patch(API_BASE, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

const RequestStatusChangeService = {
  updateRequestStatus,
};

export default RequestStatusChangeService;
